import type { CreateUserResult } from "@/lib/api";
import { ConfirmButton } from "@/components/common/ConfirmButton";
import { DialogFrame } from "@/components/common/DialogFrame";
import { InviteLinkShare } from "@/components/admin/InviteLinkShare";

interface InviteLinkDialogProps {
	open: boolean;
	invite: CreateUserResult | null;
	onClose: () => void;
}

export function InviteLinkDialog({ open, invite, onClose }: InviteLinkDialogProps) {
	if (!invite) return null;

	return (
		<DialogFrame
			open={open}
			title="招待リンクを再発行しました"
			width={480}
			onClose={onClose}
			footer={<ConfirmButton label="閉じる" variant="ghost" loading={false} onClick={onClose} />}
		>
			<div
				style={{
					padding: "10px 14px",
					borderRadius: "var(--radius-3)",
					background: "var(--warning-subtle)",
					boxShadow: "0 0 0 1px var(--warning-line)",
					fontSize: "var(--text-ui)",
					color: "var(--warning)",
					fontFamily: "var(--font-sans)",
					lineHeight: "var(--leading-normal)",
				}}
			>
				以前のリンクは無効になりました。新しいリンクは7日後に失効します。
			</div>
			<InviteLinkShare key={invite.inviteId} userId={invite.id} inviteUrl={invite.inviteUrl} />
		</DialogFrame>
	);
}
